._imageContainer_10wze_1 {
  position: relative;
}

._tagContainer_10wze_5 {
  position: absolute;
  top: 10px;
  right: 4px;
  opacity: 0.75;
}